import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import estoreSlice from "./estoreSlice";
import estoresSlice from "./estoresSlice";

export default configureStore({
  reducer: {
    user: userReducer,
    estore: estoreSlice,
    estores: estoresSlice,
  },
});
